import { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { AddButton, SearchInput, Empty } from "@/components/Bits";
import { DocumentoList } from "@/components/DocumentoList";
import { DocumentoUploadDialog, TIPOS_DOC } from "@/components/DocumentoUploadDialog";
import { Chip, ChipRow } from "@/pages/EquipamentosPage";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/lib/useFetch";

export default function DocumentosPage() {
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [tipo, setTipo] = useState("");
  const [open, setOpen] = useState(false);
  const { data, reload } = useFetch("/documentos", { q: q || undefined, tipo: tipo || undefined });
  return (
    <div data-testid="documentos-page">
      <PageHeader eyebrow="Arquivo" title="Documentos" subtitle={user.role === "cliente" ? "Laudos, contratos e manuais das suas fazendas e equipamentos." : "Laudos, contratos e manuais ligados a clientes, fazendas e equipamentos."} />
      <div className="flex gap-3 mb-4">
        <SearchInput value={q} onChange={setQ} placeholder="Buscar título ou arquivo" testId="doc-search-input" />
        {user.role !== "cliente" && <AddButton onClick={() => setOpen(true)} data-testid="doc-add-button">Enviar</AddButton>}
      </div>
      <ChipRow>
        <Chip active={!tipo} onClick={() => setTipo("")} data-testid="doc-filter-all">Todos</Chip>
        {Object.entries(TIPOS_DOC).map(([k, l]) => <Chip key={k} active={tipo === k} onClick={() => setTipo(k)} data-testid={`doc-filter-${k}`}>{l}</Chip>)}
      </ChipRow>
      {data?.length === 0 ? <Empty testId="doc-list-empty">Nenhum documento encontrado.</Empty> : <DocumentoList items={data || []} onChange={reload} />}
      <DocumentoUploadDialog open={open} onOpenChange={setOpen} onSaved={reload} />
    </div>
  );
}
